import { render, staticRenderFns } from "./ListIndicators.vue?vue&type=template&id=324515be"
import script from "./ListIndicators.vue?vue&type=script&setup=true&lang=js"
export * from "./ListIndicators.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports